<template>
  <div
    :class="{
      'main-panel-desktop': $mq !== 'xs' && $mq !== 'sm' && $mq !== 'md'
    }"
    class="pl-2 pr-1"
  >
    <v-layout row>
      <v-layout row wrap class="align-center">
        <div>
          <div class="display-1">
            {{ current ? current.name : "..." }}
          </div>
          <div v-if="showLink">
            Lien entreprise :
            {{
              `${extUrl}/refc/${current.shortid}/${encodeURI(current.techname)}`
            }}
          </div>
        </div>
        <div :class="{ 'ml-5': $mq !== 'sm' && $mq !== 'md' }">
          <div>
            <v-icon size="1.4rem" color="primary">mail</v-icon>
            {{ current.companyContactMail }}
          </div>
          <div>
            <v-icon size="1.4rem" color="primary">phone</v-icon>
            {{ current.companyContactPhone }}
          </div>
        </div>
      </v-layout>
      <div>
        <v-btn
          class="mb-3"
          color="blue"
          style="width: 100%; margin-left: 0; height: 50px; color: white"
          @click="$emit('click', nextColumn.value)"
          v-if="nextColumn"
          :disabled="!isValid"
        >
          Passer en "{{ nextColumnName }}"
          <v-icon class="ml-3">send</v-icon>
        </v-btn>
      </div>
      <v-btn
        fixed
        dark
        fab
        right
        style="bottom: 90px"
        color="accent"
        @click="$emit('displayFloatingWindows')"
        v-if="$mq === 'sm' || $mq === 'xs'"
      >
        <v-icon>chat</v-icon>
      </v-btn>
    </v-layout>
    <div>
      <v-combobox
        multiple
        v-model="currentTags"
        prefix="Ajouter des tags"
        :items="tags.existing"
        :filter="filterTags"
        append-icon
        chips
        deletable-chips
        hide-selected
        hide-no-data
        class="tag-input"
        :search-input.sync="tags.search"
        @change="onTagChange"
        @blur="onTagChange"
      />
    </div>
  </div>
</template>

<script>
import { ALL_PROSPECTS_COLUMNS } from "@/data/DefaultSettings";
import { fetchHil2 } from "@/utils";
import { toRegex } from "diacritic-regex";
import * as _ from "lodash";
import { mapState } from "vuex";
import { prospectLinkEnabled } from "@/data/prospectData";
import { EXTERNAL_URL } from "../../../../webapp-commons/config";

export default {
  name: "ProspectHeader",
  props: {
    isValid: Boolean
  },
  data() {
    return {
      extUrl: EXTERNAL_URL,
      tags: {
        existing: [],
        search: ""
      }
    };
  },
  async mounted() {
    await this.fetchTags();
  },
  methods: {
    async fetchTags() {
      this.tags.existing = await fetchHil2("get", "/prospects/tags");
    },
    filterTags(item, queryText, itemText) {
      return this.searchTagRegex.test(itemText);
    },
    onTagChange() {
      this.tags.search = "";
    }
  },
  computed: {
    ...mapState("prospects", ["current"]),
    showLink() {
      return prospectLinkEnabled(this.current);
    },
    nextColumn() {
      const columnIndex = ALL_PROSPECTS_COLUMNS.findIndex(
        v => v.value === this.current.currentProgress
      );
      return columnIndex > 0 ? ALL_PROSPECTS_COLUMNS[columnIndex + 1] : null;
    },
    nextColumnName() {
      const next = this.nextColumn;
      return next ? next.text : "";
    },
    currentTags: {
      get() {
        return this.current.tags || [];
      },
      set(value) {
        this.current.tags = value;
      }
    },
    searchTagRegex() {
      if (!this.tags.search) {
        return /./;
      }
      return toRegex({ flags: "i" })(_.escapeRegExp(this.tags.search));
    }
  }
};
</script>
